import useThemeStore from '../store/themeStore';

export default function ThemeToggle() {
	const { isDark, toggle } = useThemeStore();
	return (
		<button
			onClick={toggle}
			aria-label='Toggle theme'
			className='rounded-full p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-white/10 transition'
		>
			{isDark ? (
				// Sun icon
				<svg
					xmlns='http://www.w3.org/2000/svg'
					className='h-5 w-5'
					fill='none'
					viewBox='0 0 24 24'
					stroke='currentColor'
				>
					<path
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth={1.5}
						d='M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707M17.657 17.657l-.707-.707M6.343 6.343l-.707-.707M12 8a4 4 0 100 8 4 4 0 000-8z'
					/>
				</svg>
			) : (
				// Moon icon
				<svg
					xmlns='http://www.w3.org/2000/svg'
					className='h-5 w-5'
					fill='none'
					viewBox='0 0 24 24'
					stroke='currentColor'
				>
					<path
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth={1.5}
						d='M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z'
					/>
				</svg>
			)}
		</button>
	);
}
